import Button, { BUTTON_HEIGHT_32 } from '../../../../../Button'

import DeleteIcon from '../../../../../../icons/delete.svg'

export const QA_NAME_LISTING_PROFILE_AVAILABLE_FROM_CELL =
  'listingProfileAvailableFromCell'

export const QA_NAME_LISTING_PROFILE_AVAILABLE_FROM_INPUT =
  'listingProfileAvailableFromInput'

export const QA_NAME_LISTING_PROFILE_AVAILABLE_FROM_DELETE =
  'listingProfileAvailableFromDeleteBtn'

export const LISTING_PROFILE_AVAILABLE_FROM_ACTION_KEY_DELETE = 'delete'

export const LISTING_PROFILE_AVAILABLE_FROM_ACTIONS = [
  {
    Button: Button.Outlined,
    key: LISTING_PROFILE_AVAILABLE_FROM_ACTION_KEY_DELETE,
    props: {
      beforeIconProps: { Icon: DeleteIcon },
      height: BUTTON_HEIGHT_32,
      qaName: QA_NAME_LISTING_PROFILE_AVAILABLE_FROM_DELETE,
      tooltip: 'Modal.DeleteBtnKey',
    },
    show: contentExist => contentExist,
  },
]
